import Box from "@mui/material/Box";
import Image from "next/image";
import { baseUrl } from "@/utils/api-definition";
import { t, Trans } from "@lingui/macro";
import Typography from "@mui/material/Typography";
import { Button, useMediaQuery } from "@mui/material";
import Link from "next/link";
import React from "react";
import { useLingui } from "@lingui/react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { theme } from "@/styles/theme";
import { magicConstants } from "@/utils/magic-constants";
import { languageIds } from "@/lib/language";
import { getRequest } from "@/utils/request";
import { useGiftStore } from "@/components/context/gift-store";
import { IMenuInformation } from "@/types/header";

interface ComponentProps {
  outsideRef: any;
  lang: string;
}
const ChooseNow: React.FC<ComponentProps> = ({ outsideRef, lang }) => {
  const queryClient = useQueryClient();
  const { i18n } = useLingui();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const OFFSET_SMALL = 125;
  const OFFSET_LARGE = 175;
  const { setProductId } = useGiftStore();
  const { data: information } = useQuery({
    queryKey: ["information"],
    queryFn: () => getRequest({ path: { name: "information" }, lang }),
    staleTime: 0,
  });

  const handleChooseNow = () => {
    const scrollTop = window.scrollY;

    queryClient.invalidateQueries({ queryKey: ["product"] });
    setProductId(magicConstants.offerzVoucherId);
    if (outsideRef.current) {
      const boxTop = outsideRef.current.getBoundingClientRect().top + window.scrollY;
      let offsetTop = 0;
      if (scrollTop > 100 || isMobile) {
        offsetTop = boxTop - OFFSET_SMALL;
      } else {
        offsetTop = boxTop - OFFSET_LARGE;
      }
      window.scrollTo({ top: offsetTop, behavior: "smooth" });
    }
  };

  return (
    <>
      <Box
        sx={{
          marginTop: "45px",
          background: "#ddeaec",
          padding: "20px 20px 18px",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            columnGap: "20px",
          }}
        >
          <Image
            loading="lazy"
            src={`${baseUrl}` + "/image/gift_images/gift_page/cta-img.png"}
            width={60}
            height={60}
            alt={t(i18n)`Choose now`}
            className="hidden md:block"
          />
          <Typography sx={{ fontSize: "14px", maxWidth: "180px" }}>
            <Trans>All vouchers in one. The Offerz voucher always fits!</Trans>
          </Typography>
        </Box>
        <Button
          data-testid="product-buy"
          variant="contained"
          sx={{
            fontSize: "14px !important",
            fontWeight: 400,
            padding: "8px 12px",
            height: "40px",
            borderRadius: "4px",
          }}
          onClick={() => handleChooseNow()}
        >
          <Trans>Choose now</Trans>
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          columnGap: "20px",
          marginBottom: "40px",
          marginTop: "10px",
        }}
      >
        <Link href={`https://help.offerz.ch/hc/${lang}`} prefetch={false}>
          <Typography variant="h6" color="primary" sx={{ cursor: "pointer", textWrap: "nowrap" }}>
            <Trans>Help</Trans>?
          </Typography>
        </Link>
        <Box sx={{ display: "flex", alignItems: "center", columnGap: "5px" }}>
          <Typography sx={{ fontSize: "14px", maxWidth: "180px" }}>
            <Trans>Corporate client</Trans>?
          </Typography>
          <Link
            href={`/information/${information?.data?.items.find((item: IMenuInformation) => item.id === magicConstants.businessInformation).seo_url[languageIds[lang]]}`}
            prefetch={false}
          >
            <Typography variant="h6" color="primary" sx={{ cursor: "pointer", textWrap: "nowrap" }}>
              <Trans>This way</Trans>
            </Typography>
          </Link>
        </Box>
      </Box>
    </>
  );
};
export default ChooseNow;
